// Generated by apps/web/scripts/fetch-art-assets.mjs - do not edit by hand.
// Re-run `npm run assets:fetch -w @edcc/web` to refresh.

export const artAssetsRetrievedAt = "2026-10-18T08:17:50.822Z";

export const engineerImageByKey: Record<string, string> = 
{
  "baltanos": "/engineer-images/baltanos.webp",
  "bill-turner": "/engineer-images/bill-turner.webp",
  "broo-tarquin": "/engineer-images/broo-tarquin.webp",
  "chloe-sedesi": "/engineer-images/chloe-sedesi.webp",
  "colonel-bris-dekker": "/engineer-images/colonel-bris-dekker.webp",
  "didi-vatermann": "/engineer-images/didi-vatermann.webp",
  "domino-green": "/engineer-images/domino-green.webp",
  "eleanor-bresa": "/engineer-images/eleanor-bresa.webp",
  "elvira-martuuk": "/engineer-images/elvira-martuuk.webp",
  "etienne-dorn": "/engineer-images/etienne-dorn.webp",
  "felicity-farseer": "/engineer-images/felicity-farseer.webp",
  "hera-tani": "/engineer-images/hera-tani.webp",
  "hero-ferrari": "/engineer-images/hero-ferrari.webp",
  "jude-navarro": "/engineer-images/jude-navarro.webp",
  "juri-ishmaak": "/engineer-images/juri-ishmaak.webp",
  "kit-fowler": "/engineer-images/kit-fowler.webp",
  "lei-cheung": "/engineer-images/lei-cheung.webp",
  "liz-ryder": "/engineer-images/liz-ryder.webp",
  "lori-jameson": "/engineer-images/lori-jameson.webp",
  "marco-qwent": "/engineer-images/marco-qwent.webp",
  "marsha-hicks": "/engineer-images/marsha-hicks.webp",
  "mel-brandon": "/engineer-images/mel-brandon.webp",
  "oden-geiger": "/engineer-images/oden-geiger.webp",
  "petra-olmanova": "/engineer-images/petra-olmanova.webp",
  "professor-palin": "/engineer-images/professor-palin.webp",
  "ram-tah": "/engineer-images/ram-tah.webp",
  "rosa-dayette": "/engineer-images/rosa-dayette.webp",
  "selene-jean": "/engineer-images/selene-jean.webp",
  "terra-velasquez": "/engineer-images/terra-velasquez.webp",
  "the-dweller": "/engineer-images/the-dweller.webp",
  "the-sarge": "/engineer-images/the-sarge.webp",
  "tiana-fortune": "/engineer-images/tiana-fortune.webp",
  "tod-the-blaster-mcquinn": "/engineer-images/tod-the-blaster-mcquinn.webp",
  "uma-laszlo": "/engineer-images/uma-laszlo.webp",
  "wellington-beck": "/engineer-images/wellington-beck.webp",
  "yarden-bond": "/engineer-images/yarden-bond.webp",
  "yi-shen": "/engineer-images/yi-shen.webp",
  "zacariah-nemo": "/engineer-images/zacariah-nemo.webp"
};

export const shipImageBySlug: Record<string, string> = 
{
  "adder": "/ship-images/adder.webp",
  "alliance_challenger": "/ship-images/alliance_challenger.webp",
  "alliance_chieftain": "/ship-images/alliance_chieftain.webp",
  "alliance_crusader": "/ship-images/alliance_crusader.webp",
  "anaconda": "/ship-images/anaconda.webp",
  "asp": "/ship-images/asp.webp",
  "asp_scout": "/ship-images/asp_scout.webp",
  "beluga": "/ship-images/beluga.webp",
  "explorer_nx": "/ship-images/explorer_nx.webp",
  "cobra_mk_iii": "/ship-images/cobra_mk_iii.webp",
  "cobra_mk_iv": "/ship-images/cobra_mk_iv.webp",
  "cobra_mk_v": "/ship-images/cobra_mk_v.webp",
  "imperial_corsair": "/ship-images/imperial_corsair.webp",
  "diamondback_explorer": "/ship-images/diamondback_explorer.webp",
  "diamondback_scout": "/ship-images/diamondback_scout.webp",
  "dolphin": "/ship-images/dolphin.webp",
  "eagle": "/ship-images/eagle.webp",
  "federal_assault_ship": "/ship-images/federal_assault_ship.webp",
  "federal_corvette": "/ship-images/federal_corvette.webp",
  "federal_dropship": "/ship-images/federal_dropship.webp",
  "federal_gunship": "/ship-images/federal_gunship.webp",
  "fer_de_lance": "/ship-images/fer_de_lance.webp",
  "hauler": "/ship-images/hauler.webp",
  "imperial_clipper": "/ship-images/imperial_clipper.webp",
  "imperial_courier": "/ship-images/imperial_courier.webp",
  "imperial_cutter": "/ship-images/imperial_cutter.webp",
  "imperial_eagle": "/ship-images/imperial_eagle.webp",
  "keelback": "/ship-images/keelback.webp",
  "kestrel": "/ship-images/kestrel.webp",
  "krait_mkii": "/ship-images/krait_mkii.webp",
  "krait_phantom": "/ship-images/krait_phantom.webp",
  "mamba": "/ship-images/mamba.webp",
  "mandalay": "/ship-images/mandalay.webp",
  "orca": "/ship-images/orca.webp",
  "panther_clipper": "/ship-images/panther_clipper.webp",
  "python": "/ship-images/python.webp",
  "python_nx": "/ship-images/python_nx.webp",
  "sidewinder": "/ship-images/sidewinder.webp",
  "type_10_defender": "/ship-images/type_10_defender.webp",
  "type_11_prospector": "/ship-images/type_11_prospector.webp",
  "type_6_transporter": "/ship-images/type_6_transporter.webp",
  "type_7_transport": "/ship-images/type_7_transport.webp",
  "type_8_transport": "/ship-images/type_8_transport.webp",
  "type_9_heavy": "/ship-images/type_9_heavy.webp",
  "viper": "/ship-images/viper.webp",
  "viper_mk_iv": "/ship-images/viper_mk_iv.webp",
  "vulture": "/ship-images/vulture.webp"
};
